import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 10H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z",
    fillRule: "evenodd"
  }],
  circles: []
};
var IndeterminateCheckBoxIcon = function IndeterminateCheckBoxIcon(props) {
  return renderIcon(props, iconType);
};

export { IndeterminateCheckBoxIcon };
//# sourceMappingURL=IndeterminateCheckBoxIcon.esm.js.map
